import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, Navigate } from "react-router-dom";
import { Phone } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { BUSINESS } from "@/data/site";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Reviews from "@/pages/Reviews";
import ServiceAreas from "@/pages/ServiceAreas";
import LocationDetail from "@/pages/LocationDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Financing from "@/pages/Financing";
import Contact from "@/pages/Contact";

const ServiceDetailWrapper = () => { const { slug } = useParams(); return <ServiceDetail key={slug} />; };
const LocationWrapper = () => { const { slug } = useParams(); return <LocationDetail key={slug} />; };
const BlogWrapper = () => { const { slug } = useParams(); return <BlogPost key={slug} />; };

const FloatingCall = () => (
  <a href={BUSINESS.phoneHref} data-testid="floating-call" aria-label="Call us"
     className="lg:hidden fixed bottom-24 right-4 z-40 bg-adn-red text-white p-4 rounded-full shadow-lg hover:bg-adn-charcoal transition-colors">
    <Phone size={22} />
  </a>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <SmoothScroll>
        <Navbar />
        <main className="flex-1 pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetailWrapper />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/service-areas/:slug" element={<LocationWrapper />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogWrapper />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCall />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
